module.exports = __webpack_public_path__ + "img/menu-icon.7db466cf.svg";